import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { cartLineCardCondensedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardCondensed";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

cartLineCardCondensedStyles.productImage={
    img:{
        css:css`
            height: auto;
            width: 100%;
            max-height:105px;
            object-fit:contain;
            aspect-ratio:1/1;
        `,
    }
}

cartLineCardCondensedStyles.productDescription={
    productDetailLink:{
        css: css`
        width: 100%;
        span {
            font-size:16px;
            font-weight:600;
            color: black !important;
            &:hover {
                color:#006bc0 !important;
            }
        }
    `,
    typographyProps: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
        `,
    },
    },
}

cartLineCardCondensedStyles.productErpNumberText = {
    css: css`
        width: 100%;
        word-wrap: break-word;
        color: #006bc0 !important;
        font-size:14px;
        font-weight:500;
    `,
}

cartLineCardCondensedStyles.productPrice={
    priceLabelText:{
        variant: "legend",
        css:css`
          font-size:11px;
        `,
    }
}

cartLineCardCondensedStyles.productAvailability={
    messageGridItem:{
        width:12,
        css:css`
        div {
            padding:3px;
            margin-top:4px;
            span[class^="IconWrapper"]{
                margin-right:3px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    height:14px;
                    width:14px;
                `,
                css`
                        height:14px;
                        width:14px;
                `,
                css`
                        height:14px;
                        width:14px;
                `,
                css`
                        height:14px;
                        width:14px;
                `,
                null,
            ])}
            }
            
        }
        `,
    },
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size:11px;
                `,
                css`
                    font-size:11px;
                `,
                css`
                    font-size:11px;
                `,
                css`
                    font-size:11px;
                `,
                null,
            ])}
        `,
    },
}

cartLineCardCondensedStyles.quantity={
    editableQuantityTextField:{
        labelProps:{
        css:css`
            font-size:11px;
        `,
        }
    }
}